import { render, staticRenderFns } from "./Cierre.vue?vue&type=template&id=c55f7244"
import script from "./Cierre.vue?vue&type=script&lang=js"
export * from "./Cierre.vue?vue&type=script&lang=js"
import style0 from "../main.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports